import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Rocket } from 'lucide-react';

export const FloatingSubmitButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when user scrolls down 300px
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToForm = () => {
    document.getElementById('submission-form')?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 md:hidden animate-fade-in">
      <Button
        onClick={scrollToForm}
        size="lg"
        className="group relative px-6 py-6 shadow-2xl bg-gradient-to-r from-primary via-secondary to-accent hover:shadow-[0_0_40px_rgba(96,165,250,0.8)] transition-all duration-300 hover:scale-110"
      >
        <span className="relative z-10 flex items-center gap-2">
          <Rocket className="w-5 h-5" />
          Submit Idea
        </span>
        <div className="absolute inset-0 bg-gradient-to-r from-primary/80 via-secondary/80 to-accent/80 rounded-lg blur-xl opacity-50 group-hover:opacity-75 transition-opacity" />
      </Button>
    </div>
  );
};
